import { AxiosResponse } from "axios";
import { http } from "../../../utils";

export function fetchSitesStockPdf(partyId?: string
) {

    let url = `/charts/pvt/sites_stock_summary_pdf`
    if(partyId) {
        url = `/charts/pvt/sites_stock_summary_pdf?party_id=` + partyId
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}

export function fetchSitesStockExcel(partyId?: string
) {

    let url = `/charts/pvt/sites_stock_summary_excel`
    if(partyId) {
        url = `/charts/pvt/sites_stock_summary_excel?party_id=` + partyId
    }
    return http
        .get(
            url
        )
        .then((response: AxiosResponse) => response.data)
}